import { render, staticRenderFns } from "./MyRequestListView.vue?vue&type=template&id=32119134&scoped=true"
import script from "./MyRequestListView.vue?vue&type=script&lang=js"
export * from "./MyRequestListView.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/abiturient/MyRequestListView.css?vue&type=style&index=0&id=32119134&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32119134",
  null
  
)

export default component.exports